import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const LookupApi = {
  async getInstitutions() {
    return checkErrors(await fetchApi.lookup.get('institutions'));
  },
  async getProducts({ institution }) {
    return checkErrors(await fetchApi.lookup.get(`products/${institution}`));
  },
  async getClientTypes() {
    return checkErrors(await fetchApi.lookup.get('client-types'));
  },
  async getRoles() {
    return checkErrors(await fetchApi.lookup.get('roles'));
  },
  // The tenant's configured option lists (`uwe_lists`), and one list's items in
  // the `{ value, label }` shape a dropdown consumes. A form field normally
  // reaches these through `lookup: { api: 'lists/<name>/items' }` rather than
  // here — these are for code that needs the lists outside a form.
  async getLists() {
    return checkErrors(await fetchApi.lookup.get('lists'));
  },
  // `list` is the list's name or its id; the name is what survives a publish to
  // another environment.
  async getListItems({ list }) {
    return checkErrors(await fetchApi.lookup.get(`lists/${encodeURIComponent(list)}/items`));
  },
  async getUseMultiplesOrganizationsAndRoles() {
    return checkErrors(await fetchApi.lookup.get('useMultiplesOrganizationsAndRoles'));
  },
  async getAppOptions() {
    return checkErrors(await fetchApi.api.get('app-options'));
  },
  // Config for the AddressMapWidget form field (currently just the Google Maps API key) — lives
  // under form-lookup, not app-options, since it's form-specific config, not an app-wide flag.
  // Unauthenticated on the backend (no [Authorize]) so it also works on anonymous public forms.
  async getGoogleMapsConfig() {
    return checkErrors(await fetchApi.lookup.get('google-maps-config'));
  },
  async getRoleUsers({ roleId }) {
    return (await checkErrors(await fetchApi.lookup.get(`role/${roleId}/users`))).data;
  },
  async getSLASetting({ ignoreCache } = {}) {
    return checkErrors(
      await fetchApi.lookup.get('sla', {
        resetCache: ignoreCache,
      })
    );
  },
  async getMetadataAttributeEnum(attribute) {
    return (await checkErrors(await fetchApi.lookup.get(`metadata/enum/${attribute}`))).data;
  },
  async getUsers({ roles, inOffice, canOwn }) {
    return checkErrors(
      await fetchApi.lookup.get('users', {
        useCache: false,
        query: {
          roles: roles ? roles.join(',') : undefined,
          inOffice,
          canOwn,
        },
      })
    );
  },
  async getOrganizationalUnits(data) {
    return checkErrors(
      await fetchApi.lookup.get('organizationalunits', {
        useCache: false,
        query: data,
      })
    );
  },
};

export default LookupApi;
